import { z } from "zod";

import { REQUIRED_MESSAGE } from "@/utils";

import { baseProductSchema } from "./base-product.schema";

// Schema específico para Personal Accident (AP)
export const personalAccidentSchema = baseProductSchema
  .omit({ min_permitted_age: true, max_permitted_age: true })
  .extend({
    // Campos de idade obrigatórios para AP
    min_permitted_age: z
      .preprocess(
        (v) =>
          v === "" || v === null || v === undefined ? undefined : Number(v),
        z.number().min(0, { message: REQUIRED_MESSAGE })
      )
      .refine((val) => val !== undefined && val !== null, {
        message: REQUIRED_MESSAGE,
      }),
    max_permitted_age: z
      .preprocess(
        (v) =>
          v === "" || v === null || v === undefined ? undefined : Number(v),
        z.number().min(0, { message: REQUIRED_MESSAGE })
      )
      .refine((val) => val !== undefined && val !== null, {
        message: REQUIRED_MESSAGE,
      }),
  // Campos específicos do Personal Accident
  policy_holder: z.string().optional().nullable(),
  code_plan: z.string().optional().nullable(),
  // insurance_policy_extra_price_code é opcional para AP
  insurance_policy_extra_price_code: z.string().optional().nullable(),

  // Campos específicos de cobertura para AP
  coverage_accident_death: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_accident_disability: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_medical_expenses: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  coverage_funeral_assistance: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),

  // Campos específicos de benefícios para AP
  benefit_24h_coverage: z.boolean().optional(),
  benefit_worldwide_coverage: z.boolean().optional(),
  benefit_occupational_accident: z.boolean().optional(),
  benefit_non_occupational_accident: z.boolean().optional(),
});

export type TPersonalAccidentFormData = z.infer<typeof personalAccidentSchema>;
